module.exports = __webpack_public_path__ + "img/close.11bc73ef.png";